import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class BookingChangeService {

  constructor(private api: ApiService) { }

  get bookingChangeInProgress(): boolean {
    return this.api.bookingChangeInProgress;
  }
}
